import { getField, updateField } from 'vuex-map-fields';
import UserService from '../../services/UserService';

function getToken(){
	return new Promise((resolve, reject) => {
		document.addEventListener('deviceready', () => {
			if(typeof NativeStorage !== 'undefined') {
				console.log('NativeStorage getItem token');
				NativeStorage.getItem('token', (token) => resolve(token), () => resolve(null));
			}else{
				return resolve(localStorage.token);
			}
		});
	});
}

export default {
	state: {
		isLoggedIn: false,
		loginError: '',
		token: null,
		user: null
	},
	getters: {
		getField,
		getUserField(state) {
			return getField(state.user);
		},
		isLoggedIn: state => state.isLoggedIn,
		loginError: state => state.loginError,
	},
	actions: {
		async logInByToken({ commit, dispatch }) {

			const token = await getToken();
			commit('setToken', token);

			await UserService.loginByToken()
				.then((payload) => {
					commit('logInUser', payload);
				})
				.catch((error) => {
					dispatch('logout');
					throw error;
				});
		},
		async logInUser({ commit, dispatch }, _credentials) {
			dispatch('logout');
			await UserService.login(_credentials)
				.then((payload) => {
					if(typeof NativeStorage !== 'undefined') {
						console.log('NativeStorage setItem token');
						NativeStorage.setItem('token', payload.token, () => commit('logInUser', payload));
					}else{
						localStorage.token = payload.token;
						commit('logInUser', payload);
					}
				})
				.catch((error) => {
					throw error;
				});
		},
		updateUser({state}) {
			return UserService.update(state.user);
		},
		logout({ commit }) {
			if(typeof NativeStorage !== 'undefined') {
				console.log('NativeStorage remove token');
				NativeStorage.remove('token', () => commit('logout'));
			}else {
				localStorage.removeItem('token');
				commit('logout');
			}
		},
	},
	mutations: {
		updateField,
		updateUserField(state, field) {
			updateField(state.user, field);
		},
		setToken(state, payload) {
			state.token = payload;
		},
		logout(state) {
			state.isLoggedIn = false;
			state.loginError = '';
			state.token = null;
			state.user = null;
		},
		logInUser(state, payload) {
			state.token = payload.token;
			state.loginError = '';
			state.isLoggedIn = true;
			state.user = payload.user;
		},
		loginError(state) {
			state.isLoggedIn = false;
			state.token = null;
			state.user = null;
			state.loginError = 'De login gegevens zijn niet correct';
		},
	},
};
